export default function buildRedirectUri(path) {
  return `${window.location.origin}${path}`;
}
